import { h } from 'preact'

/* eslint-disable max-len */

const Trade = ({ fill }) => (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 60" fill={fill}>
        <path
            d="M0,17.2c0-0.3,0.2-0.6,0.4-0.8l0,0L20.6,0.2l0,0C20.8,0.1,21,0,21.2,0c0.6,0,1,0.5,1,1v9.1c9.2,0.5,24.3,7.6,24.3,21.2V35
            l-1.9-3.1c-0.1-0.1-5.8-9.2-22.4-9.6v9.1c0,0.6-0.5,1-1,1c-0.2,0-0.4-0.1-0.6-0.2l0,0L0.4,18l0,0C0.2,17.8,0,17.5,0,17.2z"
        />
        <path
            d="M48,42.8c0,0.3-0.2,0.6-0.4,0.8l0,0L27.4,59.8l0,0C27.2,59.9,27,60,26.8,60c-0.6,0-1-0.5-1-1v-9.1
            c-9.2-0.5-24.3-7.6-24.3-21.2V25l1.9,3.1c0.1,0.1,5.8,9.2,22.4,9.6v-9.1c0-0.6,0.5-1,1-1c0.2,0,0.4,0.1,0.6,0.2l0,0L47.6,42l0,0
            C47.8,42.2,48,42.5,48,42.8z"
        />
    </svg>
)

Trade.defaultProps = {
    fill: '',
}

export default Trade
